export default __webpack_public_path__ + "static/1-37-0-event-page-819290911572b0f5547dd44d693f6c0a.png";